module.exports = __webpack_public_path__ + "static/media/concierge.9a6bd3c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/concierge.svg
// module id = 1515
// module chunks = 0